import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import api from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const { darkMode } = useTheme();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      await api.post('/usuarios/request-password-reset', { email });
      setMessage('E-mail de recuperação enviado! Verifique sua caixa de entrada.');
    } catch (err) {
      if (err.response?.status === 429) {
        const retryAfter = err.response?.data?.retryAfter;
        const minutes = Math.ceil(retryAfter / 60);
        setError(`Muitas tentativas. Aguarde ${minutes} minuto(s) para tentar novamente.`);
      } else {
        setError(err.response?.data?.message || 'Erro ao enviar e-mail de recuperação');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 ${darkMode ? 'content-bg-dark' : 'bg-gray-100'}`}>
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto flex items-center justify-center">
            <img
              src="/assets/logo_nomoz.png"
              width={177}
              height={65}
              alt="Nomoz Logo"
            />
          </div>
          <h2 className={`mt-6 text-center text-3xl font-extrabold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
            Recuperar Senha
          </h2>
          <p className={`mt-2 text-center text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Digite seu e-mail para receber o link de recuperação
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {message && (
            <div className="rounded-md bg-green-50 p-4">
              <p className="text-sm text-green-800">{message}</p>
            </div>
          )}

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}

          <div>
            <label htmlFor="email" className="sr-only">E-mail</label>
            <input
              id="email"
              name="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`block w-full rounded-md shadow-sm py-2 px-3 ${
                darkMode
                  ? 'bg-zinc-600 border border-gray-700 text-white focus:ring-green-500 focus:border-green-500'
                  : 'bg-white border border-gray-300 text-gray-900 focus:ring-green-500 focus:border-green-500'
              }`}
              placeholder="Seu e-mail"
            />
          </div>

          <div className="flex flex-col space-y-3">
            <button
              type="submit"
              disabled={loading}
              className="gradient-button w-full"
            >
              {loading ? 'Enviando...' : 'Enviar Link de Recuperação'}
            </button>

            <button
              type="button"
              onClick={() => navigate('/login')}
              className="secondary-button w-full"
            >
              Voltar ao Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
